import 'simplebar/dist/simplebar.css';
import Select from 'components/select';
import {createElement} from 'methods/utils';
import IMask from 'imask';
import ComponentElement from 'components/component-element';
import DateRangePicker from 'components/daterangepicker-dropdown';
import PeoplePicker from 'components/peoplepicker';
import {ajaxGetData} from 'methods/ajaxData';
import retail from 'components/retailrocket';

function Form(options = {}) {
    const $form = createElement(`
        <form action="/save_tourist_leads/" class="Tourist-leads-form__form search-v2 js-tourist-leads-form"></form>
    `);

    ComponentElement.call(this, $form, options);
    this.$form = this.$element;
    this.$form .addEventListener('submit', this.submit.bind(this));
}

Form.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(Form.prototype, 'constructor', {
    value: Form,
    enumerable: false,
    writable: true,
});

Form.prototype.section = function(data = {}) {
    this.$form.insertAdjacentHTML('beforeend', `
        <div class="Tourist-leads-form__section${data.cls ? ` Tourist-leads-form__section--${data.cls}` : ''} js-tourist-leads-form-section"></div>    
    `)

    for (const [name, options] of Object.entries(data)) {
        if (!this[name] || this.$form.querySelector(`[name="${name}"]`)) {
            continue;
        }

        this[name](options);
    }

    return this;
}

Form.prototype.getSection = function() {
    const sections = this.$form.querySelectorAll('.js-tourist-leads-form-section');
    return sections[sections.length - 1];
}

Form.prototype.appendToSection = function(html) {
    this.getSection().insertAdjacentHTML('beforeend', html);
}

Form.prototype.getFieldHTML = function(options = {}) {
    const autocompleteDefaults = {
        name: 'given-name',
        email: 'email',
        phone: 'tel',
        destination: 'off',
        comment: 'off',
    };
    const autocomplete = options.autocomplete ?? autocompleteDefaults[options.name] ?? '';

    return `
        <div class="Input${options.hidden ? ' is-hidden' : ''} js-tourist-leads-${options.name}-input" data-name="${options.name}">
            <label class="Input__label" for="${options.id}">${options.label}${options.required ? '<em>*</em>' : ''}</label>
            <input class="Input__field" type="${options.type || 'text'}"${options.value ? ` value="${options.value}"` : ''} id="${options.id}" name="${options.name}" placeholder="${options.placeholder}"${options.required ? ' required' : ''}${options.hidden ? ' hidden' : ''}${autocomplete ? ` autocomplete="${autocomplete}"` : ''}/>
            ${options.message ? `<div class="Input__message${options?.message?.show ? ' is-active' : ''} js-tourist-leads-message">${options?.message?.text}</div>` : ''}
        </div>
    `;
}

Form.prototype.getInputHTML = function(options = {}) {
    return `<input name="${options.name}" id="${options.id}" ${options.value ? ` value="${options.value}"` : ''} hidden />`;
}

Form.prototype.input = function(options = {}) {
    this.appendToSection(this.getInputHTML(options));
}

Form.prototype.description = function(text) {
    this.appendToSection(`
        <div class="Tourist-leads-form__description">
            ${text}
        </div>
    `);
}

Form.prototype.name = function(options = {}) {
    this.appendToSection(
        this.getFieldHTML({
            id: 'name',
            name: 'name',
            label: 'Имя', 
            required: false, 
            placeholder: 'Имя', 
            message: '',
            ...options,
        })
    );
}

Form.prototype.destination = function(options = {}) {
    this.appendToSection(
        this.getFieldHTML({
            id: 'destination',
            name: 'destination',
            value: '', 
            label: 'Курорт', 
            required: true, 
            placeholder: 'Название курорта', 
            message: 'Заполните данные для продолжения',
            ...options,
        })
    );
}

Form.prototype.email = function(options = {}) {
    this.appendToSection(
        this.getFieldHTML({
            id: 'email',
            name: 'email',
            value: '', 
            label: 'Емейл', 
            required: true, 
            placeholder: 'example@mail.ru', 
            message: {
                text: 'Свяжемся с вами по телефону, а на почту отправим подтверждение заявки',
                show: true,
            },
            ...options,
        })
    );

    this.$email = this.$form.elements['email'];
}

Form.prototype.phone = function(options = {}) {
    const phoneFormats = window?.pageData?.phone_formats || [];
    if (!phoneFormats.length) {
        return;
    }

    this.appendToSection(`
        <div class="Input js-tourist-leads-phone-input" data-name="phone">
            <label class="Input__label" for="phone">Мобильный телефон<em>*</em></label>
            <div class="Input__container">
                <div class="Input__select">
                    <div class="Select" data-name="country">
                        <div class="Select-selected-wrapper">
                            <div class="Select-selected">
                                ${phoneFormats[0].code}
                            </div>
                            <div class="Select-arrow"></div>
                        </div>
                        <div class="Select-items">
                            ${phoneFormats.map((country) => (
                                `<div class="Select-item" data-value="${country.code}" data-format="${country.format}">${country.code}</div>`
                            )).join('')}
                        </div>
                    </div>
                </div>
                <div class="Input__wrapper">
                    <input class="Input__field" type="tel" id="phone" name="phone" autocomplete="tel" />
                </div>
            </div>
            <div class="Input__message js-tourist-leads-message">Заполните данные для продолжения</div>
        </div>
    `);

    this.initPhoneField();
}

Form.prototype.pickers = function(options = {}) {
    const {
        datePicker = {}, 
        peoplePicker = {},
        message = 'Заполните данные для продолжения', 
    } = options;

    if (!datePicker && !peoplePicker) return;

    this.appendToSection(`
        <div class="Tourist-leads-form__search js-searchContainer">
            <div class="Tourist-leads-form__search-pickers js-tourist-leads-pickers"></div>
            <div class="Tourist-leads-form__search-error js-tourist-leads-message">${message}</div>
        </div>
    `);

    const $pickers = this.$form.querySelector('.js-tourist-leads-pickers');
    
    if (datePicker) {
        $pickers.insertAdjacentHTML('beforeend', `
            <div class="date-wrapper js-dateRangePicker">
                <div class="date-container">
                    <div class="date-item">
                        <input type="hidden" name="date_start" value="">
                        <div class="date-label">Заезд${datePicker.required ? '<em>*</em>' : ''}</div>
                        <div class="date-input date-input--muted" data-name="date_start">Дата</div>
                    </div>
                    <div class="date-item">
                        <input type="hidden" name="date_finish" value="">
                        <div class="date-label">Выезд${datePicker.required ? '<em>*</em>' : ''}</div>
                        <div class="date-input date-input--muted" data-name="date_finish">Дата</div>
                        <div class="date-reset is-hidden js-rangeReset">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.307 7.69289C16.6976 8.08342 16.6976 8.71658 16.307 9.10711L13.4142 12L16.307 14.8929C16.6976 15.2834 16.6976 15.9166 16.307 16.3071C15.9165 16.6976 15.2834 16.6976 14.8928 16.3071L11.9999 13.4142L9.10705 16.3071C8.71653 16.6976 8.08336 16.6976 7.69284 16.3071C7.30231 15.9166 7.30231 15.2834 7.69284 14.8929L10.5857 12L7.69284 9.10711C7.30231 8.71658 7.30231 8.08342 7.69284 7.69289C8.08336 7.30237 8.71653 7.30237 9.10705 7.69289L11.9999 10.5858L14.8928 7.69289C15.2834 7.30237 15.9165 7.30237 16.307 7.69289Z" fill="#D4D2D8"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        `);

        this.datePicker = new DateRangePicker($pickers.querySelector('.js-dateRangePicker'), {
            formInputClass: 'date-input',
            canShowPlate: false,
            ...datePicker,
        });
    }

    if (peoplePicker) {
        $pickers.insertAdjacentHTML('beforeend', `
            <div class="people-wrapper js-peoplePicker">
                <div class="people-container">
                    <div class="people-item">
                        <div class="people-label">Количество гостей</div>
                        <div class="people-input people-input--muted" data-title="total">Кто поедет?</div>
                    </div>
                </div>
            </div>
        `);

        this.peoplePicker = new PeoplePicker($pickers.querySelector('.js-peoplePicker'), {
            formInputClass: 'people-input',
            withPets: true,
            ...peoplePicker,
        });
    }

    ajaxGetData().then((r) => {
        let data = r.data.search;

        if (this.datePicker && data.date_start && data.date_finish) {
            // _disableCallbacks нужен, чтобы не отрабатывал callback rangeSelect
            this.datePicker._disableCallbacks = true;
            this.datePicker.rangeSelect(new Date(data.date_start), new Date(data.date_finish));

            // apply нужен, чтобы прокидывать даты в рендер
            this.datePicker.apply();
            this.datePicker._disableCallbacks = false;
        }

        // люди
        if (this.peoplePicker) {
            if (data.adults) {
                this.peoplePicker.setAdults(data.adults);
            }

            this.peoplePicker.setChildrenOlds(data.children_olds);
        }
    });

    this.$searchContainer = this.$form.querySelector('.js-searchContainer');
}

Form.prototype.comment = function(options = {}) {
    const opts = {
        label: 'Ваши Пожелания', 
        rows: 4, 
        placeholder: 'Хочу отель с питанием на первой линии, нужен бассейн и детская игровая площадка....',
        ...options,
    };

    this.appendToSection(`
        <div class="Input js-tourist-leads-comment-input">
            <label class="Input__label" for="comment">${opts.label}</label>
            <textarea class="Input__field" rows="${opts.rows}" name="comment" id="comment" placeholder="${opts.placeholder}" autocomplete="off"></textarea>
        </div>
    `);
}

Form.prototype.agreement = function(options = {}) {
    this.appendToSection(`
        <label class="Tourist-leads-form__checkbox checkbox">
            <input class="js-tourist-leads-form-agreement" type="checkbox" name="agreement">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect class="checkbox__background" width="24" height="24" rx="8"></rect>
                <rect class="checkbox__border" x="0.75" y="0.75" width="22.5" height="22.5" rx="7.25" stroke="#D4D2D8" stroke-width="1.5"></rect>
                <path class="checkbox__mark" fill-rule="evenodd" clip-rule="evenodd" d="M19.6898 6.27599C20.0897 6.65696 20.105 7.28994 19.724 7.68979L10.1966 17.6898C10.0079 17.8879 9.74621 18 9.4726 18C9.19898 18 8.93732 17.8879 8.74859 17.6898L4.27599 12.9953C3.89503 12.5955 3.91035 11.9625 4.31021 11.5815C4.71007 11.2006 5.34305 11.2159 5.72401 11.6158L9.4726 15.5503L18.276 6.31021C18.657 5.91035 19.2899 5.89503 19.6898 6.27599Z" fill="white"></path>
            </svg>
            <span class="Tourist-leads-form__checkbox-title">
                Я согласен на <a href="/about/soglasie_na_obrabotku_personalnyh_dannyh/" target="_blank">обработку своих персональных данных</a>
            </span>
        </label>
    `);

    this.$agreement = this.$form.querySelector('[name="agreement"]');
}

Form.prototype.mailing = function(options = {}) {
    this.appendToSection(`
        <label class="Tourist-leads-form__checkbox checkbox">
            <input class="js-tourist-leads-form-mailing" type="checkbox" name="mailing"${options.required ? ' required' : ''}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect class="checkbox__background" width="24" height="24" rx="8"></rect>
                <rect class="checkbox__border" x="0.75" y="0.75" width="22.5" height="22.5" rx="7.25" stroke="#D4D2D8" stroke-width="1.5"></rect>
                <path class="checkbox__mark" fill-rule="evenodd" clip-rule="evenodd" d="M19.6898 6.27599C20.0897 6.65696 20.105 7.28994 19.724 7.68979L10.1966 17.6898C10.0079 17.8879 9.74621 18 9.4726 18C9.19898 18 8.93732 17.8879 8.74859 17.6898L4.27599 12.9953C3.89503 12.5955 3.91035 11.9625 4.31021 11.5815C4.71007 11.2006 5.34305 11.2159 5.72401 11.6158L9.4726 15.5503L18.276 6.31021C18.657 5.91035 19.2899 5.89503 19.6898 6.27599Z" fill="white"></path>
            </svg>
            <div class="Tourist-leads-form__checkbox-texts">
                <span class="Tourist-leads-form__checkbox-title">
                    Хочу получать подборки жилья и спецпредложения от ПриветТур
                </span>
                <span class="Tourist-leads-form__checkbox-caption">
                    Без спама и только по делу
                </span>
            </div>
        </label>
    `);

    this.$mailing = this.$form.querySelector('[name="mailing"]');
}

Form.prototype.submitter = function(options = {}) {
    this.appendToSection(`
        <button class="Tourist-leads-form__submitter Tourist-leads-form__submitter--${options.variant || 'primary'} js-tourist-leads-form-submitter" type="submit" ${options.disabled ? 'disabled' : ''}>
            ${options.text || 'Подобрать варианты'}
        </button>
    `);

    this.$submitter = this.$form.querySelector('.js-tourist-leads-form-submitter');
    
    // валидация
    this.$form.addEventListener('change', (event) => {
        this.$submitter.disabled = !this.validate();
    });

    // для валидации выше
    this.$form.addEventListener('input', (event) => {
        const $input = event.target;

        if ($input.name == 'email') {
            $input.dispatchEvent(new Event('change', {bubbles: true}));
        }
    });
}

Form.prototype.initPhoneField = function() {
    let $inputPhone = this.$form.elements['phone'];
    if (!$inputPhone) {
        return;
    }

    const self = this;

    let onChange = function(value, index) {
        let $option = self._phoneSelect.getSelectedItem();

        // форматирование маски под стиль JS
        let mask = $option.dataset.format.replace(/\\d\{(\d+)\}/g, function(match, count) {
            return '0'.repeat(count);
        });

        if (self._phoneImask) {
            self._phoneImask.destroy();
            $inputPhone.value = '';
        }

        if (!$inputPhone.value) {
            $inputPhone.value = mask.replace(/^(\+\d+)(.*)$/g, '$1');
        }

        self._phoneImask = new IMask($inputPhone, {
            mask: mask,
        });
    }

    this._phoneSelect = new Select(this.$form.querySelector('.Select[data-name="country"]'), {
        on: {
            change: onChange,
            ready:  onChange,
        },
    });
}

Form.prototype.validate = function() {
    if (!this.$agreement?.checked) {
        return false;
    }

    if (this.$email?.required && !this.$email.value) {
        return false;
    }

    return true;
}

// Подписка на рассылку
Form.prototype.subscribe = function() {
    const email = this.$form.elements['email']?.value;
    const phone = this.$form.elements['phone']?.value;
    const subs_place = this.$form.elements['subs_place']?.value;
    const Name = this.$form.elements['name']?.value;

    // согласие на рассылку, если false - то рассылку не получает
    const isAgreedToReceiveMarketingMail = this.$form.elements['mailing']?.checked;

    retail.setProfile({
        email,
        phone,
        isAgreedToReceiveMarketingMail,
        customData: {
            Name,
            [subs_place]: true,
        }
    });

    if (email && isAgreedToReceiveMarketingMail) {
        retail.welcomeSequence(email);
    }
}

Form.prototype.submit = function(e) {
    e.preventDefault();

    if (this.$submitter) {
        if (this.$submitter.disabled || this.$submitter.classList.contains('is-loading')) {
            return;
        }

        this.$submitter.classList.add('is-loading');
        this.$submitter.disabled = true;
    }

    const formData = new FormData(this.$form);

    if (this?.options?.source) {
        formData.append('source', this.options.source);
    } else {
        formData.append('source', 'site');
    }

    // на какой мы странице
    formData.append('location_url', location.href);

    // откуда пришли
    formData.append('referrer_url', document.referrer);

    this.clearErrors();

    fetch(this.$form.action, {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    })
    .then((response) => {
        if (this.$submitter) {
            this.$submitter.classList.remove('is-loading');
            this.$submitter.disabled = false;
        }

        if (response.status === 'error') {
            this.showErrors(response.fields);
        }

        if (response.status === 'ok') {
            if (this.$form.elements['email'].value) {
                this.subscribe(); 
            }

            this.resetForm();
            this.emit('submit');
        }
    })
    .catch((error) => {
        console.error('Error submitting form:', error);
        this.$submitter.classList.remove('is-loading');
        this.$submitter.disabled = false;
    })
}

Form.prototype.showErrors = function(fields) {
    fields.forEach((field) => {
        if (field.type === 'date_start' || field.type === 'date_finish') {
            this.$searchContainer.classList.add('is-error');
            this.$searchContainer.querySelector('.js-tourist-leads-message').textContent = field.message;
            
            return;
        }

        const $inputContainer = this.$form.querySelector(`.Input[data-name="${field.type}"]`);
        if (!$inputContainer) {
            return;
        }

        const $message = $inputContainer.querySelector('.js-tourist-leads-message');
        if (!$message) {
            return;
        }

        $inputContainer.classList.add('Input--error');
        $inputContainer.classList.remove('is-hidden');
        $inputContainer.querySelector('input').hidden = false;
        $message.textContent = field.message;
    });
}

Form.prototype.clearErrors = function() {
    this.$form.querySelectorAll('.Input--error').forEach(($input) => {
        $input.classList.remove('Input--error');
    });

    if (this.$searchContainer) {
        this.$searchContainer.classList.remove('is-error');
    }
}

Form.prototype.resetForm = function() {
    // Сброс DateRangePicker
    if (this.datePicker && typeof this.datePicker.rangeReset === 'function') {
        this.datePicker.rangeReset();
    }

    // Сброс PeoplePicker
    if (this.peoplePicker && typeof this.peoplePicker.reset === 'function') {
        this.peoplePicker.reset({
            adults: 1,
            petReset: true,
        });
    }

    // Очистка текстовых полей
    const $destination = this.$form.elements['destination'];
    if ($destination && !$destination.hidden) {
        $destination.value = '';
    }

    const $comment = this.$form.elements['comment'];
    if ($comment) {
        $comment.value = '';
    }

    const $name = this.$form.elements['name'];
    if ($name) {
        $name.value = '';
    }

    // Сброс галочки
    const $submitter = this.$form.querySelector('.js-tourist-leads-form-submitter');

    const $agreement = this.$form.elements['agreement'];
    if ($agreement) {
        $agreement.checked = false;

        if ($submitter) {
            $submitter.disabled = true;
        }
    }

    const $mailing = this.$form.elements['mailing'];
    if ($mailing) {
        $mailing.checked = false;

        if ($submitter) {
            $submitter.disabled = true;
        }
    }

    // Сброс телефона
    const $phone = this.$form.elements['phone'];
    if ($phone) {
        $phone.value = '+7';

        // Сброс Select страны на первый элемент (это вызовет onChange и создаст новый IMask)
        if (this._phoneSelect && typeof this._phoneSelect.reset === 'function') {
            this._phoneSelect.reset();
        } else if (this._phoneSelect && typeof this._phoneSelect.setSelectedIndex === 'function') {
            this._phoneSelect.setSelectedIndex(0);
        }
    }
}

export default Form;